import { api } from "@/api";

class API {
  static getTaker(payload) {
    return api.get(
      `/v1/gruposeconomicos/${payload.grupo_id}/tomadores/cotacao`,
      {
        params: {
          modalidade_id: payload.modalidade_id,
          submodalidade_id: payload.submodalidade_id
        }
      }
    );
  }
  static getApiCalls(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}/logs`);
  }
  static getEconomicGroup(payload) {
    return api.get("/v1/gruposeconomicos/cotacaocurrentuser", {
      params: {
        modalidade_id: payload.modalidade_id,
        submodalidade_id: payload.submodalidade_id
      }
    });
  }
  static getResourceType() {
    return api.get("/v1/garantia/recursal/tiposrecurso/suggest");
  }
  static getInsured(payload) {
    return api.get(`/v1/segurados/cotacao/`, {
      params: {
        query: payload.query,
        tipo_pessoa_id: payload.tipoPessoa.id
      }
    });
  }
  static getAddressApi(payload) {
    return api.get(`/v1/consultacep/${payload}`);
  }
  static getListQuotation(payload) {
    return api.get(`/v1/garantia/cotacoes${payload}`);
  }
  static getListQuotationAgro(payload) {
    return api.get(`/v1/agro/cotacoes${payload}`);
  }
  static getUserTaker() {
    return api.get(`v1/gruposeconomicos/tomadores/suggest`);
  }
  static getModalities() {
    return api.get("/v1/garantia/modalidades/suggestcurrentuser");
  }
  static getSubModalities(id) {
    return api.get(
      `/v1/garantia/modalidades/${id}/submodalidades/suggestcurrentuser`
    );
  }
  static getEgModalities(payload) {
    return api.get(`/v1/garantia/modalidades/grupoeconomico/${payload}`);
  }
  static getListClassificacaoSolo(idSubmodalidade) {
    return api.get(
      `/v1/agro/agricola/classificacaoSolo/listar/${idSubmodalidade}`
    );
  }
  static putFavoriteCompany(payload) {
    // Neste caso, se ele for favorito, tenho que desfavoritar ele
    // e vice-versa
    const isFavorite = !payload.favorite ? "favoritar" : "desfavoritar";
    return api.put(
      `/v1/gruposeconomicos/${payload.idEconomicGroup}/tomadores/${payload.idTaker}/${isFavorite}`
    );
  }
  // Usado apenas em processo eletrônico
  static getNumberProcess(payload) {
    return api.get(
      `/v1/judiciario/${payload.id}/numeracaounica/${payload.number}`
    );
  }
  // Usado apenas em processo físico
  static getJusticeRegion(payload) {
    return api.get(`/v1/judiciario/${payload}/tribunais/suggest`);
  }
  // Usado apenas em processo físico
  static getCourtJustice(payload) {
    return api.get(
      `/v1/judiciario/${payload.segmentID}/tribunais/${payload.justiceID}/unidades/suggest`
    );
  }
  static getDeadlineByTaker(payload) {
    return api.get(
      `/v1/gruposeconomicos/${payload.economicGroup.id}/tomadores/${payload.taker.id}/prazos`,
      {
        params: {
          modalidade_id: payload.modalidade_id,
          submodalidade_id: payload.submodalidade_id
        }
      }
    );
  }
  static postNewQuotation(payload) {
    return api.post("/v1/garantia/cotacoes", payload);
  }
  static postNewQuotationAgro(payload) {
    return api.post("/v1/agro/cotacoes", payload);
  }
  static postContractDataQuotationAgro(payload) {
    return api.post("/v1/agro/cotacoes/dadoscontratacao", payload);
  }
  static requestLogQuotationAgro(idQuotation) {
    return api.get(`/v1/agro/cotacoes/logCotacaoAgro/${idQuotation}`);
  }
  static getCurrentQuotationAgro(payload) {
    return api.get(`/v1/agro/cotacoes/${payload}`);
  }
  //Cancelar cotação quando clicar no botão Cancelar Solicitação.
  static putCancelQuotationAgro(payload) {
    return api.put(`/v1/agro/cotacoes/${payload}/cancelar`);
  }
  //Aprovação da cotação Agro
  static putApproveDraftContractQuotationAgro(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/aprovar/${value.payload.forma_pagamento}`,
      value.payload
    );
  }
  //Aprovação da cotação Cafezal
  static putApproveDraftContractQuotationCafezal(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/aprovarcafezal/${value.payload.forma_pagamento}`,
      value.payload
    );
  }
  //Envia os custos da cotação agro
  static postQuotationCostsAgro(payload) {
    return api.post(`/v1/agro/agricola/custo/adicionar`, payload);
  }
  //Traz um único custo da cotação agro.
  static getQuotationCostsAgro(payload) {
    return api.get(`/v1/agro/agricola/custo/${payload}`);
  }
  //Traz a lista de custos inseridos pelo id da cotação.
  static getListQuotationCostsAgro(payload) {
    return api.get(`/v1/agro/agricola/custo/${payload}/listar`);
  }

  //Atualiza o documento quando sai da tela proposta e entra na conformidade Agro
  static putAgroAgreement(value) {
    return api.put(`/v1/agro/agricola/custo/card/${value.form.id}/gerar`);
  }

  //Atualiza o documento quando sai da tela proposta e entra na conformidade Cafezal
  static putCafezalAgreement(value) {
    return api.put(
      `/v1/agro/agricola/custo/card/${value.form.id}/gerarCafezal`
    );
  }

  //Envia o arquivo para anexado para o back.
  static postUploadAgroAgreement(payload) {
    return api.put(`/v1/agro/agricola/custo/arquivo/upload`, payload);
  }

  //Envia o arquivo para anexado para o back.
  static postUploadCafezalAgreement(payload) {
    return api.put(`/v1/agro/agricola/custo/arquivoCafezal/upload`, payload);
  }

  //consulta da aprovação para atualizar os cards
  static getUploadAgroAgreement(payload) {
    return api.get(`/v1/agro/agricola/custo/card/${payload}`);
  }

  //Aprova o arquivo anexado.
  static putApproveUploadAgroAgreement(payload) {
    return api.put(`/v1/agro/agricola/custo/arquivo/aprovar`, payload);
  }
  //Rejeita o arquivo anexado.
  static putRejectUploadAgroAgreement(payload) {
    return api.put(`/v1/agro/agricola/custo/arquivo/reprovar`, payload);
  }
  static putProposalAgro(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/proposta`,
      value.payload
    );
  }
  static putProposalCafezal(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/propostaCafezal`,
      value
    );
  }
  static putPolicyAgro(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/apolice`,
      value.payload
    );
  }
  static putPolicyCafezal(value) {
    return api.put(
      `/v1/agro/agricola/custo/${value.id}/apoliceCafezal`,
      value.payload
    );
  }
  static getCurrentQuotation(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}`);
  }
  static getListCriticism(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}/criticas`);
  }
  static postCriticism(value) {
    return api.post(
      `/v1/garantia/cotacoes/${value.id}/criticas`,
      value.payload
    );
  }
  static postResendCriticism(value) {
    return api.post(
      `/v1/garantia/cotacoes/${value.cotacao}/criticas/${value.critica}/reenviar`
    );
  }
  static putResolveCriticism(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/criticas/${value.critica}/regularizar`
    );
  }
  static putQuotation(value) {
    return api.put(`/v1/garantia/cotacoes/${value.id}`, value.payload);
  }
  static getCurrentQuotationToEdit(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}/edicao`);
  }
  static getYearsAccordingEconomicGroup(payload) {
    return api.get(
      `/v1/gruposeconomicos/${payload.grupo}/tomadores/${payload.tomador}/prazos`,
      {
        params: {
          modalidade_id: payload.modalidade_id,
          submodalidade_id: payload.submodalidade_id
        }
      }
    );
  }
  static postDraftContract(value) {
    return api.post(`/v1/garantia/cotacoes/${value.id}/minuta`, value.payload);
  }
  static putSolicitDraftContract(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/minuta/solicitar`,
      value.payload
    );
  }
  static putApproveDraftContract(payload) {
    return api.put(`/v1/garantia/cotacoes/${payload}/minuta/aprovar`);
  }
  static putSolicitApproveDraftContract(payload) {
    return api.put(
      `/v1/garantia/cotacoes/${payload}/minuta/solicitaraprovacao`
    );
  }
  static putSolicitPolicyContract(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.id}/apolice/solicitarparaseguradora`,
      value.payload
    );
  }
  static putRejectDraftContract(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.id}/minuta/recusar`,
      value.payload
    );
  }
  static putChosenInsuranceInQuotation(payload) {
    return api.put(`/v1/garantia/cotacoes/${payload.cotacao}/gerarcotacao`);
  }
  static putCancelQuotation(payload) {
    return api.put(`/v1/garantia/cotacoes/${payload.id}/cancelar`, {
      justificativa: payload.justification
    });
  }
  static postPolicyContract(value) {
    return api.post(`/v1/garantia/cotacoes/${value.id}/apolice`, value.payload);
  }
  static getHistoricalActions(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}/historicoacoes`);
  }
  static putDeclineDraftContract(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.id}/minuta/registrardeclinio`,
      value.payload
    );
  }
  static getItemsCriticism(payload) {
    return api.get(`/v1/garantia/cotacoes/criticas/acompanhar${payload}`);
  }
  static getStatusCurrentQuotation(payload) {
    return api.get(`/v1/garantia/cotacoes/${payload}/status`);
  }
  static getListOfficeQuotation(payload) {
    return api.get("/v1/escritorios/cotacao", {
      params: {
        grupo_economico_id: payload
      }
    });
  }
  static getOptionsQuotation(payload) {
    return api.get("/v1/garantia/cotacoes/opcoes", {
      params: {
        submodalidade_id: payload
      }
    });
  }
  static putRefuseDrafContractQuotation(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/minuta/recusar`,
      value.payload
    );
  }
  static putRequestDraftContractQuotation(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/formalizarcotacaosolicitarminuta`
    );
  }
  static putApproveDraftContractQuotation(payload) {
    return api.put(
      `/v1/garantia/cotacoes/${payload.cotacao}/seguradora/${payload.seguradora}/minuta/aprovar`
    );
  }
  static putApprovalDraftContractQuotation(payload) {
    return api.put(
      `/v1/garantia/cotacoes/${payload.cotacao}/seguradora/${payload.seguradora}/minuta/solicitaraprovacao`
    );
  }
  static putCostQuotation(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/custos`,
      value.payload
    );
  }
  static putDeclineCostQuotation(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/declinar`,
      value.payload
    );
  }
  static getItemsInsuranceToEmail(payload) {
    return api.get(`/v1/seguradoras/listarseguradoraemail/${payload}`);
  }
  static postEmailInsuranceQuotation(value) {
    return api.post(
      `/v1/garantia/emails/${value.id}/email/enviar`,
      value.payload
    );
  }
  static putRemoveDraftContractQuotation(payload) {
    return api.put(
      `/v1/garantia/cotacoes/${payload.cotacao}/seguradora/${payload.seguradora}/minuta/remover`
    );
  }
  static putReactivateCostQuotation(value) {
    return api.put(
      `/v1/garantia/cotacoes/${value.cotacao}/seguradora/${value.seguradora}/custos/reativar`,
      value.payload
    );
  }
  static getCafezalEspecieOptions() {
    return api.get(`v1/agro/cafezal/especiecafe/suggest`);
  }
  static getCafezalVariedadeOptions() {
    return api.get(`v1/agro/cafezal/variedadecafe/suggest`);
  }
  static getCafezalSistemaCultivoOptions() {
    return api.get(`v1/agro/cafezal/sistemacultivocafe/suggest`);
  }
  static getBanksList() {
    return api.get(`/v1/bancos/suggest`);
  }
}

export default API;
